<template>
   <v-container>
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>

        <v-row v-if="!loading">
            <v-col class="col-md-4" v-for="item in items" v-bind:key="item['@id']"> 
                <v-card elevation="0" tile>
                        <v-card-text @click="openPost(item)">
                            <a style="text-decoration: none; color: #185EA9;">
                            <h3 
                                style="overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; font-family: 'Google Sans', Helvetica,Arial,sans-serif;"
                            >{{item.title}}</h3>
                            <v-img 
                                class="img-responsive" 
                                max-width="100%"
                                :src="discovery.magnolia_base_url + item.image['@link']">
                            </v-img>
                            </a>
                        </v-card-text>
                    </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import api from '../../api/magnolia'
import discovery from '../../discovery'

export default {
  name: 'HelpModule',
  components: {
  },

  data () {
      return { 
        loading: false,
        items: {},
        discovery: discovery
      }
    },
  methods: {
        openPost(post) {
            let url = discovery.magnolia_base_url + '/detalle-noticia/dynacontent/' + post['@path'].replace('/Tweem/','') + '.html';
            window.open(url);
        },
        getPosts() {
            this.loading =true;
            api.getPosts (data=> {
                this.items =data.results;
                this.loading =false;
            }, err => {
                console.log(err);
            })
        },
  }, 
  mounted: function ()  {
      let me = this;
      this.$nextTick(() => {
                me.getPosts();
        });
  },
  }
</script>

